export const iconFontAwesomeMusicVideoMicrophoneSlash = (
	<i className="fa-solid fa-microphone-slash"></i>
);
